import React from 'react';
import { useMsal } from '@azure/msal-react';
import styled from 'styled-components/macro';
import { Logout } from '@mui/icons-material';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';


export const SignOutButton = () => {
  const { instance } = useMsal();

  function handleLogout() {
    instance.logoutRedirect({
      postLogoutRedirectUri: `https://msft.sts.microsoft.com`,
    }).catch(e => {
      console.error(e);
    });
  }

  return (
    <Wrapper>
      <ListItem button onClick={handleLogout}>
        <ListItemIcon>
          <Logout fontSize='medium' htmlColor='white' />
        </ListItemIcon>
        <ListItemText disableTypography style={{ fontSize: '14px' }} primary={'Logout'} />
      </ListItem>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background-color: ${p => p.theme.primary};
  color: white;
  font-size: 14px;
`;
